<template>
  <div v-if="progressStore.visible" class="progress-container">
    <div class="progress-header">
      <span class="font-bold">{{ progressStore.title }}</span>
      <span class="progress-counter"
        >{{ progressStore.current }} / {{ progressStore.total }}
        {{ progressStore.totalsLabel }}</span
      >
    </div>
    <div class="progress-bar-container">
      <div
        class="progress-bar"
        :style="{ width: progressStore.progressPercentage + '%' }"
      ></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useProgressStore } from '@/stores/progressStore';

// Use the store instead of props
const progressStore = useProgressStore();
</script>

<style lang="scss" scoped>
.progress-container {
  width: 100%;
  margin-bottom: $space-3;
}

.progress-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: $space-3;
}

.progress-counter {
  font-size: 0.9em;
  color: $color-text-dark;
}

.progress-bar-container {
  height: $space-2;
  width: 100%;
  background-color: $color-neutral-500;
  border-radius: $radius-max;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: $color-primary-500;
  border-radius: $radius-max;
  transition: width 0.3s ease;
}
</style>
